export const PROFESSION_CHOICES = [
  {
    id: "lakare",
    label: "Läkare",
    color: "#c62828",
    textColor: "#ffffff",
    articleNumber: "YRK-0204",
  },
  {
    id: "sjukskoterska",
    label: "Sjuksköterska",
    color: "#1565c0",
    textColor: "#ffffff",
    articleNumber: "YRK-0205",
  },
  {
    id: "barnmorska",
    label: "Barnmorska",
    color: "#1565c0",
    textColor: "#ffffff",
    articleNumber: "YRK-0206",
  },
  {
    id: "underskoterska",
    label: "Undersköterska",
    color: "#2e7d32",
    textColor: "#ffffff",
    articleNumber: "YRK-0207",
  },
  {
    id: "fysioterapeut",
    label: "Fysioterapeut",
    color: "#ef6c00",
    textColor: "#ffffff",
    articleNumber: "YRK-0208",
  },
  {
    id: "arbetsterapeut",
    label: "Arbetsterapeut",
    color: "#ef6c00",
    textColor: "#ffffff",
    articleNumber: "YRK-0209",
  },
  {
    id: "vardadministrator",
    label: "Vårdadministratör",
    color: "#7b1fa2",
    textColor: "#ffffff",
    articleNumber: "YRK-0210",
  },
  {
    id: "administrativ_samordnare",
    label: "Administrativ samordnare",
    color: "#7b1fa2",
    textColor: "#ffffff",
    articleNumber: "YRK-0211",
  },
  {
    id: "tandlakare",
    label: "Tandläkare",
    color: "#4fc3f7",
    textColor: "#ffffff",
    articleNumber: "YRK-0212",
  },
  {
    id: "tandhygienist",
    label: "Tandhygienist",
    color: "#4fc3f7",
    textColor: "#ffffff",
    articleNumber: "YRK-0213",
  },
  {
    id: "tandskoterska",
    label: "Tandsköterska",
    color: "#4fc3f7",
    textColor: "#ffffff",
    articleNumber: "YRK-0214",
  },
  {
    id: "receptionist",
    label: "Receptionist",
    color: "#4fc3f7",
    textColor: "#ffffff",
    articleNumber: "YRK-0215",
  },
  {
    id: "ortopedassistent",
    label: "Ortopedassistent",
    color: "#4fc3f7",
    textColor: "#ffffff",
    articleNumber: "YRK-0216",
  },
  {
    id: "biomedicinsk_analytiker",
    label: "Biomedicinsk analytiker",
    color: "#7b1e3a",
    textColor: "#ffffff",
    articleNumber: "YRK-0217",
  },
  {
    id: "servicepersonal",
    label: "Servicepersonal",
    color: "#212121",
    textColor: "#ffffff",
    articleNumber: "YRK-0218",
  },
  {
    id: "student",
    label: "Student",
    color: "#ffffff",
    textColor: "#000000",
    articleNumber: "YRK-0219",
  },
  {
    id: "elev",
    label: "ELEV",
    color: "#ffffff",
    textColor: "#000000",
    articleNumber: "YRK-0219-2",
  },
  {
    id: "omvårdnadsassistent",
    label: "Omvårdnadsassistent",
    color: "#ffffff",
    textColor: "#000000",
    articleNumber: "YRK-0219-3",
  },
];